<style scoped>
.el-row {
    height: 100%;
}

.el-row {
    border-right: none;
}

.el-aside {
    border-right: 1px solid #f5f1f1;
}
</style>

<template>
    <el-aside width="200px">
        <el-row class="tac">
            <el-col>
                <el-menu default-active="1" class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleOpen"
                >

                    <el-menu-item v-if="group&32 || group&16 || group&8" 
                        index="1" @click="goPage('userManage')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">内容管理</span>
                    </el-menu-item>

                    <el-menu-item  v-if="group&32 || group&16 || group&8 || group&4 || group&2" 
                        index="2" @click="goPage('operationData')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">运营数据</span>
                    </el-menu-item>

                    <el-submenu  v-if="group&32 || group&16 || group&4 || group&2" 
                        index="3">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">活动中心</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="3-1" @click="goPage('ActivityList')">常驻活动</el-menu-item>
                            <el-menu-item index="3-2" @click="goPage('CatGuessList')">竞猜活动</el-menu-item>
                            <el-menu-item index="3-3" @click="goPage('GuessList')">竞猜列表</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>

                    <el-submenu  v-if="group&32 || group&16 || group&4 || group&2" 
                        index="4">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">任务中心</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="4-1" @click="goPage('taskConfig')">任务总览</el-menu-item>
                            <el-menu-item index="4-2" @click="goPage('inventory')">库存管理</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>

                    <el-menu-item  v-if="group&32 || group&16 || group&2" 
                        index="4" @click="goPage('toolManage')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">道具管理</span>
                    </el-menu-item>

                    <el-menu-item  v-if="group&32 || group&16 || group&2" 
                        index="5" @click="goPage('activityManager')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">商城管理</span>
                    </el-menu-item>
                
                    <el-menu-item  v-if="group&32 || group&16 || group&2" 
                        index="6" @click="goPage('cardManage')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">猫卡管理</span>
                    </el-menu-item>

                    <el-submenu   v-if="group&32 || group&16 || group&1" 
                        index="7">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">用户邮件</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="7-1" @click="goPage('presentMail')">活动奖励邮件</el-menu-item>
                            <el-menu-item index="7-2" @click="goPage('systemMail')">系统邮件</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>

                    <el-submenu  v-if="group&32 || group&16 || group&1" 
                        index="8">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">用户资料</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="8-1" @click="goPage('consoleUserInfo')">后台用户管理</el-menu-item>
                            <el-menu-item index="8-2" @click="goPage('clientUserInfo')">客户端用户管理</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>

                    <el-menu-item  v-if="group&32 || group&16 || group&4" 
                        index="9" @click="goPage('baseActive')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">场地调试</span>
                    </el-menu-item>

                    <el-submenu  v-if="group&32" 
                        index="10">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">账号管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="10-1" @click="goPage('createUser')">创建用户</el-menu-item>
                            <el-menu-item index="10-2" @click="goPage('propsConfig')">物品配置</el-menu-item>
                            <el-menu-item index="10-3" @click="goPage('catCardConfig')">猫卡配置</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>

                    <el-menu-item  v-if="group&32 || group&16" 
                        index="11" @click="goPage('approveCenter')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">审批中心</span>
                    </el-menu-item>

                    <el-menu-item  v-if="group&32 || group&16 || group&1" 
                        index="12" @click="goPage('momentList')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">首页动态</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
        </el-row>
    </el-aside>
</template>

<script>
import app from "@/App.vue";
var $this = {};
export default {
    data() {
        return {
            group: app.globalData.userInfo.group,
        };
    },
    beforeCreate() {
        $this = this;
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },

        goPage(url) {
            if (url === "userManage") {
                $this.$router.push("/Layout/userManage").catch(error => error);
            } else if (url === "operationData") {
                $this.$router.push("/Layout/operationData").catch(error => error);
            } else if (url === "ActivityList") {
                $this.$router.push("/Layout/ActivityList").catch(error => error);
            } else if (url === "CatGuessList") {
                $this.$router.push("/Layout/CatGuessList").catch(error => error);
            } else if (url === "GuessList") {
                $this.$router.push("/Layout/GuessList").catch(error => error);
            } else if (url === "catCommonActivity") {
                $this.$router.push("/Layout/CatCommonActivity").catch(error => error);
            } else if (url === "toolManage") {
                $this.$router.push("/Layout/toolManage").catch(error => error);
            } else if (url === "cardManage") {
                $this.$router.push("/Layout/cardManage").catch(error => error);
            } else if (url === "userMail") {
                $this.$router.push("/Layout/userMail").catch(error => error);
            } else if (url === "consoleUserInfo") {
                $this.$router.push("/Layout/consoleUserInfo").catch(error => error);
            } else if (url === "clientUserInfo") {
                $this.$router.push("/Layout/clientUserInfo").catch(error => error);
            } else if (url === "createUser") {
                $this.$router.push("/Layout/createUser").catch(error => error);
            } else if (url === "baseActive") {
                $this.$router.push("/Layout/baseActive").catch(error => error);
            } else if (url === "accountManage") {
                $this.$router.push("/Layout/accountManage").catch(error => error);
            } else if (url === "propsConfig") {
                $this.$router.push("/Layout/propsConfig").catch(error => error);
            } else if (url === "catCardConfig") {
                $this.$router.push("/Layout/catCardConfig").catch(error => error);
            } else if (url === "approveCenter") {
                $this.$router.push("/Layout/approveCenter").catch(error => error);
            } else if (url === "taskConfig") {
                $this.$router.push("/Layout/taskConfig").catch(error => error);
            } else if (url === "inventory") {
                $this.$router.push("/Layout/inventory").catch(error => error);
            } else if (url === "momentList") {
                $this.$router.push("/Layout/momentList").catch(error => error);
            } else if (url === "presentMail") {
                $this.$router.push("/Layout/PresentMail").catch(error => error);
            } else if (url === "systemMail") {
                $this.$router.push("/Layout/SystemMail").catch(error => error);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/nav.vue